import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import cardRejectedLabel from '@perpay-web/fintech/assets/images/CardRejectedLabel.svg';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { useShopPath } from '@perpay-web/fintech/hooks/useShopPath';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { useMount } from '@perpay-web/hooks/useMount';
import { formatCurrencyConditionalCents } from '@perpay-web/utils/stringUtils';

import styles from './CardRejected.scss';

const CardRejected = ({
    onClickDashboard,
    onClickShop,
    onMount,
    isLoading,
    spendingLimit,
}) => {
    const { shopPath } = useShopPath();

    useMount(onMount);

    if (isLoading) return null;

    const formattedSpendingLimit =
        formatCurrencyConditionalCents(spendingLimit);

    return (
        <div className={styles.wrapper}>
            <LegacyFocusLayout
                className={styles.container}
                contentClassName={styles.content}
                footer={
                    <div className={styles.footer}>
                        <CardCta
                            Component={CustomLink}
                            href={shopPath}
                            onClick={() => onClickShop()}
                            className={styles['footer__shop-button']}
                        >
                            Shop Now
                        </CardCta>
                        <CustomLink
                            href={paths.dashboard.path}
                            onClick={onClickDashboard}
                            className={styles['footer__dashboard-link']}
                        >
                            View dashboard
                        </CustomLink>
                    </div>
                }
            >
                <div className={styles.heading}>
                    <ResponsiveHeader className={styles.header}>
                        Your card application was not approved
                    </ResponsiveHeader>
                    <ResponsiveCopy className={styles.copy}>
                        Please check your email for more information on this
                        decision. This decision will not impact your credit
                        score.
                    </ResponsiveCopy>
                </div>
                <div className={styles.card}>
                    <div className={styles.section__top}>
                        <div className={styles.pill}>Approved</div>
                        <div className={styles['spending-limit']}>
                            {formattedSpendingLimit}
                        </div>
                        <div className={styles.description}>
                            Approved spending limit to shop the Perpay
                            Marketplace
                        </div>
                        <img
                            src={cardRejectedLabel}
                            className={styles['illustration-label']}
                            alt='Label'
                        />
                        <div className={styles.illustration} />
                    </div>
                    <div className={styles.section__bottom}>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Increase your chances of getting approved for the
                            Perpay Credit Card.
                        </div>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Shop top brands and make interest-free installments
                            from your paycheck.
                        </div>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Build credit across the 3 major credit bureaus:
                            Experian, Equifax and TransUnion.
                        </div>
                    </div>
                </div>
            </LegacyFocusLayout>
        </div>
    );
};

export default CardRejected;
